module.exports = __webpack_public_path__ + "static/img/ibayPayLogo.a59b1535.png";